<template>
  <div v-if="visivel" class="caixa-modal-overlay" @click.self="$emit('fechar')">
    <div class="caixa-modal">
      <header class="caixa-modal__header">
        <h3>
          <i :class="['fas', isSangria ? 'fa-arrow-up' : 'fa-arrow-down']"></i>
          {{ isSangria ? "Sangria de Caixa" : "Suprimento de Caixa" }}
        </h3>
        <button class="caixa-modal__close" @click="$emit('fechar')">×</button>
      </header>

      <div class="caixa-modal__body">
        <label class="caixa-modal__label">Valor</label>
        <input
          ref="valorInput"
          v-model.number="valor"
          type="number"
          min="0.01"
          step="0.01"
          class="caixa-modal__input caixa-modal__input--valor"
          @keydown.enter.prevent="confirmar"
        />

        <label class="caixa-modal__label">Motivo / Observação <span style="color:#dc2626">*</span></label>
        <input
          v-model="descricao"
          type="text"
          class="caixa-modal__input"
          :placeholder="isSangria ? 'Ex.: Retirada para banco' : 'Ex.: Reforço de troco'"
        />

        <p v-if="erro" class="caixa-modal__error">
          <i class="fas fa-exclamation-circle"></i> {{ erro }}
        </p>

        <p v-if="avisoImpressao" class="caixa-modal__warn">
          <i class="fas fa-exclamation-triangle"></i> {{ avisoImpressao }}
        </p>
      </div>

      <footer class="caixa-modal__footer">
        <button class="btn btn-light" :disabled="processando" @click="$emit('fechar')">Cancelar</button>
        <button :class="['btn', isSangria ? 'btn-warning' : 'btn-info']" :disabled="processando" @click="confirmar">
          <span v-if="processando">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Salvando...
          </span>
          <span v-else>Confirmar</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import CaixaPdvDesktopService from "@/modules/PdvDesktop/services/CaixaPdvDesktopService";

export default {
  name: "MovimentoCaixaModal",
  props: {
    visivel: { type: Boolean, default: false },
    tipo:    { type: String,  default: "sangria" }, // 'sangria' | 'suprimento'
  },
  data() {
    return {
      valor:           0,
      descricao:       "",
      erro:            "",
      avisoImpressao:  "",
      processando:     false,
    };
  },
  computed: {
    isSangria() { return this.tipo === "sangria"; },
  },
  watch: {
    visivel(v) {
      if (v) {
        this.valor = 0;
        this.descricao = "";
        this.erro = "";
        this.avisoImpressao = "";
        this.$nextTick(() => this.$refs.valorInput && this.$refs.valorInput.focus());
      }
    },
  },
  methods: {
    async confirmar() {
      this.erro = "";
      this.avisoImpressao = "";
      const v = Number(this.valor) || 0;
      if (v <= 0) {
        this.erro = "Valor deve ser maior que zero.";
        return;
      }
      if (!this.descricao || !this.descricao.trim()) {
        this.erro = "Informe o motivo/observação.";
        return;
      }
      this.processando = true;
      try {
        const fn = this.isSangria
          ? CaixaPdvDesktopService.registrarSangria.bind(CaixaPdvDesktopService)
          : CaixaPdvDesktopService.registrarSuprimento.bind(CaixaPdvDesktopService);
        const reg = await fn({ valor: v, descricao: this.descricao });

        // Se a impressão falhou, avisa mas não desfaz a operação
        if (reg && reg.impressao && reg.impressao.ok === false) {
          this.avisoImpressao =
            "Operação registrada, mas não foi possível imprimir o comprovante. Você poderá reimprimir depois.";
          // Emite mesmo assim, mas aguarda o usuário fechar
          this.$emit("registrado", reg);
          return;
        }
        this.$emit("registrado", reg);
      } catch (e) {
        this.erro = e.message || "Erro ao registrar movimento.";
      } finally {
        this.processando = false;
      }
    },
  },
};
</script>

<style scoped>
.caixa-modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 4000;
}
.caixa-modal {
  background: #fff; border-radius: 8px;
  width: 100%; max-width: 420px;
  box-shadow: 0 12px 32px rgba(0,0,0,0.3);
  display: flex; flex-direction: column; overflow: hidden;
}
.caixa-modal__header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px 20px; border-bottom: 1px solid #e5e7eb;
}
.caixa-modal__header h3 { margin: 0; font-size: 1.1rem; color: #1f2937; }
.caixa-modal__header h3 i { color: var(--primary-color, #ee7361); margin-right: 6px; }
.caixa-modal__close {
  background: transparent; border: 0; font-size: 1.6rem; cursor: pointer; color: #6b7280;
}
.caixa-modal__body { padding: 18px 20px; }
.caixa-modal__label { display: block; font-size: 0.85rem; color: #4b5563; margin: 10px 0 4px; }
.caixa-modal__input {
  width: 100%; padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 6px;
  font-size: 0.95rem;
}
.caixa-modal__input--valor { font-size: 1.4rem; font-weight: 600; text-align: right; }
.caixa-modal__error { color: #b91c1c; font-size: 0.85rem; margin-top: 10px; }
.caixa-modal__warn  { color: #92400e; background: #fef3c7; padding: 8px 10px;
                       border-radius: 6px; font-size: 0.82rem; margin-top: 10px; }
.caixa-modal__footer {
  display: flex; justify-content: flex-end; gap: 8px;
  padding: 14px 20px; background: #f9fafb; border-top: 1px solid #e5e7eb;
}
</style>
